module.exports = __webpack_public_path__ + "static/home-1-1-83a0365bdaf00cb4c74cbaaa3c3e4f4d.png";